<div class="header">{{'deliveryChecklist.customerAcknowledgement' | translate}}</div>
<div class="requiredMessage" [innerHTML]="'deliveryChecklist.selectAllRequired' | translate"></div>
<div class="row">
    <div class="col-xl-6 col-lg-9 col-sm-12 col-md-12">
        <div class="Signature">

            <p class="user-text" *ngIf='!technicianSignatureObject.id'> {{'deliveryChecklist.salesDeliveryConsultant' |
                translate}} |
                {{'deliveryChecklist.incomplete' | translate}}<span style="margin-left: 10px;">
                    <svg *ngIf='!isLexus' width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="8" fill="#CC0000" />
                    </svg>
                    <svg *ngIf='isLexus' width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="8" fill="#0D6AFF" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M10.55 11.67C10.5 11.63 10.439 11.6 10.38 11.58C10.319 11.55 10.26 11.53 10.189 11.52C10 11.479 9.8 11.5 9.62 11.58C9.49 11.63 9.38 11.7 9.29 11.79C9.109 11.979 9 12.24 9 12.5C9 12.77 9.1 13.02 9.29 13.21C9.39 13.3 9.5 13.37 9.62 13.42C9.74 13.47 9.87 13.5 10 13.5C10.13 13.5 10.26 13.47 10.38 13.42C10.5 13.37 10.609 13.3 10.71 13.21C10.8 13.109 10.87 13 10.92 12.88C10.97 12.76 11 12.63 11 12.5C11 12.24 10.89 11.979 10.71 11.79C10.66 11.75 10.609 11.7 10.55 11.67ZM11 7.5V9.5C11 10.053 10.553 10.5 10 10.5C9.447 10.5 9 10.053 9 9.5V7.5C9 6.947 9.447 6.5 10 6.5C10.553 6.5 11 6.947 11 7.5Z"
                            fill="white" />
                    </svg>

                </span></p>
            <p class="user-text" *ngIf='technicianSignatureObject.id'>{{'deliveryChecklist.salesDeliveryConsultant' |
                translate}} |
                {{'deliveryChecklist.completed' | translate}}<span style="margin-left: 10px;">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="8" fill="#21f705" />
                    </svg>
                </span></p>
            <fieldset *ngIf="technicianSignatureObject.id && !isShowTechSpinner" class="dc-box">
                <legend  class="legend-class">Signature Details</legend>
                <div class="row metaData-container">
                    <div class="metaData-text">{{'searchCustomer.firstName' | translate}} :</div>
                    <div class="metaData-value">{{technicianSignatureObject.firstName}}</div>
                    <div class="metaData-text">{{'searchCustomer.lastName' | translate}} :</div>
                    <div class="metaData-value">{{technicianSignatureObject.lastName}}</div>
                    <div class="metaData-text">{{'deliveryChecklist.date' | translate}} :</div>
                    <div class="metaData-value">{{technicianSignatureObject.date | date:
                        'MM/dd/yyyy' }}</div>
                    <div class="image-box">
                        <img class="image" [src]="technicianSignatureObject.data" alt="signature">
                    </div>
                </div>

            </fieldset>
            <fieldset *ngIf="!technicianSignatureObject.id && !isShowTechSpinner" class="add-dc-box">
                <legend  class="legend-class">Add Signature</legend>
                <button mat-button [disabled]="!enableSig" class="secondary-button Signature-button"
                    (click)="addSignature('TECHNICIAN')">
                    <em class="tmi icon tmi-edit"></em> {{'deliveryChecklist.addSignature' | translate}}</button>
            </fieldset>
            <fieldset *ngIf="isShowTechSpinner">
                <legend  class="legend-class">Fetching Data</legend>
                <app-loading size="0.8" color="var(--primary-sec-color)" loadingSymbol="dots">
                </app-loading>
            </fieldset>
        </div>
    </div>

    <div class="col-xl-6 col-lg-9 col-sm-12 col-md-12">
        <div class="Signature">
            <p class="user-text" *ngIf='!customerSignatureObject.id'> {{'deliveryChecklist.customer' | translate}} |
                {{'deliveryChecklist.incomplete' | translate}}<span style="margin-left: 10px;">
                    <svg *ngIf='!isLexus' width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="8" fill="#CC0000" />
                    </svg>
                    <svg *ngIf='isLexus' width="20" height="20" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="8" fill="#0D6AFF" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M10.55 11.67C10.5 11.63 10.439 11.6 10.38 11.58C10.319 11.55 10.26 11.53 10.189 11.52C10 11.479 9.8 11.5 9.62 11.58C9.49 11.63 9.38 11.7 9.29 11.79C9.109 11.979 9 12.24 9 12.5C9 12.77 9.1 13.02 9.29 13.21C9.39 13.3 9.5 13.37 9.62 13.42C9.74 13.47 9.87 13.5 10 13.5C10.13 13.5 10.26 13.47 10.38 13.42C10.5 13.37 10.609 13.3 10.71 13.21C10.8 13.109 10.87 13 10.92 12.88C10.97 12.76 11 12.63 11 12.5C11 12.24 10.89 11.979 10.71 11.79C10.66 11.75 10.609 11.7 10.55 11.67ZM11 7.5V9.5C11 10.053 10.553 10.5 10 10.5C9.447 10.5 9 10.053 9 9.5V7.5C9 6.947 9.447 6.5 10 6.5C10.553 6.5 11 6.947 11 7.5Z"
                            fill="white" />
                    </svg>

                </span></p>
            <p class="user-text" *ngIf='customerSignatureObject.id'>{{'deliveryChecklist.customer' | translate}} |
                {{'deliveryChecklist.completed' | translate}}<span style="margin-left: 10px;">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="8" fill="#21f705" />
                    </svg>
                </span></p>
            <fieldset *ngIf="customerSignatureObject.id" class="dc-box">
                <legend  class="legend-class">Customer Details</legend>
                <div class="row metaData-container">
                    <div class="metaData-text">{{'searchCustomer.firstName' | translate}} :</div>
                    <div class="metaData-value">{{customerSignatureObject.firstName}}</div>
                    <div class="metaData-text">{{'searchCustomer.lastName' | translate}} :</div>
                    <div class="metaData-value">{{customerSignatureObject.lastName}}</div>
                    <div class="metaData-text">{{'deliveryChecklist.date' | translate}} :</div>
                    <div class="metaData-value">{{customerSignatureObject.date | date:
                        'MM/dd/yyyy' }}</div>
                    <div class="image-box">
                        <img class="image" [src]="customerSignatureObject.data" alt="signature">
                    </div>
                </div>

            </fieldset>
            <fieldset *ngIf="!customerSignatureObject.id" class="add-dc-box">
                <legend class="legend-class">Add Signature</legend>
                <button mat-button [disabled]="!enableSig" class="secondary-button Signature-button"
                    (click)="addSignature('CUSTOMER')">
                    <em class="tmi icon tmi-edit"></em> {{'deliveryChecklist.addSignature' | translate}}</button>
            </fieldset>
        </div>
    </div>
</div>